/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import {
    PREFERENCES_SET,
    PREFERENCES_RECEIVE,
    PREFERENCES_FETCH,
    PREFERENCES_FETCH_SUCCESS,
    PREFERENCES_FETCH_FAILURE,
    PREFERENCES_SAVE_SUCCESS,
} from 'state/action-types';

import { createReducer } from 'state/utils';

export const localValues = createReducer(
    {},
    {
        [PREFERENCES_SET]: (state, { key, value }) => {
            if (state[key] === value) {
                return state;
            }

            return { ...state, [key]: value };
        },
        [PREFERENCES_SAVE_SUCCESS]: (state, { key }) => {
            return omit(state, key);
        },
    },
);

export const remoteValues = createReducer(null, {
    [PREFERENCES_RECEIVE]: (state, { values }) => values,
});

export const fetching = createReducer(false, {
    [PREFERENCES_FETCH_SUCCESS]: () => false,
    [PREFERENCES_FETCH_FAILURE]: () => false,
    [PREFERENCES_FETCH]: () => true,
});

const lastFetchedTimestamp = createReducer(false, {
    [PREFERENCES_FETCH_SUCCESS]: () => Date.now(),
});

export default combineReducers({
    localValues,
    remoteValues,
    fetching,
    lastFetchedTimestamp,
});
